<form [formGroup]="eventForm">
  <div class="container my-5">
    <div class="row mb-lg-4 mb-sm-1 m-1">
      <h1 class="page-title mt-4" #topOfPage>{{ postId ? "Activiteit wijzigen" : "Nieuwe activiteit maken"}}</h1>
    </div>





    <div [hidden]="currentStep !== 1">
      <div class="row mb-2 mb-md-4 m-1">
        <p class="activity-text mb-lg-4 mb-sm-2">
          <i class="numbered-icon">1</i>
          Vertel ons over je activiteit
        </p>
        <label for="activityname-input" class="form-label">Naam activiteit</label>
        <input type="text" class="form-control form-input" formControlName="name" id="activityname-input">
        <div class="errors p-0" *ngIf="name?.errors && firstStepSubmitted">
          <small class="text-danger" *ngIf="name?.errors?.['required']">Dit veld is vereist.</small>
          <small class="text-danger" *ngIf="name?.errors?.['minlength']">De naam van de activiteit moet minimaal 4 karakters lang zijn.</small>
        </div>
      </div>
      <div class="row mb-2 mb-md-4 m-1">
        <label for="description-input" class="form-label">Beschrijving</label>
        <textarea class="form-control form-textarea" formControlName="description" id="description-input" rows="8"></textarea>
        <div class="errors p-0" *ngIf="description?.errors && firstStepSubmitted">
          <small class="text-danger" *ngIf="description?.errors?.['required']">Dit veld is vereist.</small>
          <small class="text-danger" *ngIf="description?.errors?.['minlength']">De beschrijving van de activiteit moet minimaal 50 karakters lang zijn.</small>
        </div>
      </div>
      <div class="row mb-2 mb-md-4 m-1">
        <label for="category-input" class="form-label">Categorie activiteit</label>
        <select class="form-select" formControlName="category" id="category-input">
          <option disabled selected value="">Selecteer een categorie</option>
          <option *ngFor="let category of categories" value="{{ category.name }}">{{ category.name }}</option>
        </select>
        <div class="errors p-0" *ngIf="category?.errors && firstStepSubmitted">
          <small class="text-danger" *ngIf="category?.errors?.['required']">Selecteer een categorie uit de dropdown.</small>
        </div>
      </div>
      <div class="row mb-4 m-1">
        <label class="form-label">Voor wie is de activiteit geschikt</label>
        <div>
          <div *ngFor="let accessibility of accessibilityTags" class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="{{ accessibility.tag }}Check" id="{{ accessibility.tag }}Check">
            <label class="form-check-label" for="{{ accessibility.tag }}Check">
              {{ accessibility.long }}
            </label>
          </div>
        </div>
        <div class="errors p-0" *ngIf="categoryError">
          <small class="text-danger">{{ categoryError }}</small>
        </div>
      </div>
      <div class="row w-100 w-md-75 m-auto">
        <button (click)="changeStep(true, 1)" class="btn btn-primary mb-2 mb-md-4 btn-next btn-first m-auto">Volgende stap</button>
      </div>
    </div>





    <div [hidden]="currentStep !== 2">
      <div class="row mb-2 mb-md-4 align-items-baseline m-1 gx-3">
        <p class="activity-text">
          <i class="numbered-icon">2</i>Waar is de activiteit?
        </p>
        <div class="col ps-0">
          <label for="zipcode-input" class="form-label">Postcode</label>
          <input type="text" class="form-control form-input" formControlName="zipcode" id="zipcode-input" (input)="onZipcodeOrHouseNumberChange()">
          <div class="errors p-0" *ngIf="zipcode?.errors && secondStepSubmitted">
            <small class="text-danger" *ngIf="zipcode?.errors?.['required']">Dit veld is vereist.</small>
            <small class="text-danger" *ngIf="zipcode?.errors?.['pattern']">Voer een geldige postcode in.</small>
          </div>
        </div>
        <div class="col pe-0">
          <label for="number-input" class="form-label">Huisnummer</label>
          <input type="text" class="form-control form-input" formControlName="houseNumber" id="number-input" (input)="onZipcodeOrHouseNumberChange()">
          <div class="errors p-0" *ngIf="houseNumber?.errors && secondStepSubmitted">
            <small class="text-danger" *ngIf="houseNumber?.errors?.['required']">Dit veld is vereist.</small>
            <small class="text-danger" *ngIf="houseNumber?.errors?.['pattern']">Voer een geldig huisnummer in.</small>
          </div>
        </div>
      </div>
      <div class="row mb-2 mb-md-4 m-1">
        <label for="description-input" class="form-label">Plaats</label>
        <input type="text" class="form-control form-input" formControlName="location" id="locale-input">
        <div class="errors p-0" *ngIf="location?.errors && secondStepSubmitted">
          <small class="text-danger" *ngIf="location?.errors?.['required']">Dit veld is vereist.</small>
          <small class="text-danger" *ngIf="location?.errors?.['minlength']">De plaatsnaam van de activiteit moet minimaal 2 karakters lang zijn.</small>
        </div>
      </div>
      <div class="row mb-2 mb-md-4 m-1">
        <label for="activityname-input" class="form-label">Straatnaam</label>
        <input type="text" class="form-control form-input" formControlName="streetName" id="streetname-input">
        <div class="errors p-0" *ngIf="streetName?.errors && secondStepSubmitted">
          <small class="text-danger" *ngIf="streetName?.errors?.['required']">Dit veld is vereist.</small>
        </div>
      </div>
      <div class="row mb-2 mb-md-4 m-1 gx-3">
        <p class="activity-text">
          <i class="numbered-icon">3</i>Wanneer is de activiteit?
        </p>
        <div class="col ps-0">
          <label for="starttime-input" class="form-label">Starttijd</label>
          <input type="time" class="form-control form-input" formControlName="startTime" id="starttime-input">
          <div class="errors p-0" *ngIf="startTime?.errors && secondStepSubmitted">
            <small class="text-danger" *ngIf="startTime?.errors?.['required']">Dit veld is vereist.</small>
          </div>
        </div>
        <div class="col pe-0">
          <label for="endtime-input" class="form-label">Eindtijd</label>
          <input type="time" class="form-control form-input" formControlName="endTime" id="endtime-input">
          <div class="errors p-0" *ngIf="endTime?.errors && secondStepSubmitted">
            <small class="text-danger" *ngIf="endTime?.errors?.['required']">Dit veld is vereist.</small>
          </div>
        </div>
      </div>
      <div class="row mb-4 m-1">
        <label for="date-input" class="form-label">Datum</label>
        <input type="date" class="form-control form-input" id="date-input" formControlName="activityDate" placeholder="DD-MM-JJJJ" min="{{ minDate }}" max="{{ maxDate }}">
        <div class="errors p-0" *ngIf="activityDate?.errors && secondStepSubmitted">
          <small class="text-danger" *ngIf="activityDate?.errors?.['required']">Dit veld is vereist.</small>
          <small class="text-danger" *ngIf="activityDate?.errors?.['inPast']">Kies een activiteit datum die in de toekomst ligt.</small>
          <small class="text-danger" *ngIf="activityDate?.errors?.['afterDate']">De activiteit mag niet zo ver in de toekomst gepland worden. Kies een datum die dichterbij ligt.</small>
        </div>
      </div>
      <div class="row mb-2 mb-md-4 m-1">
        <div class="col ps-0">
          <button (click)="changeStep(false, 2)" class="col btn btn-primary btn-previous">Vorige stap</button>
        </div>
        <div class="col pe-0">
          <button (click)="changeStep(true, 2)" class="col btn btn-primary btn-next">Volgende stap</button>
        </div>
      </div>
    </div>





    <div [hidden]="currentStep !== 3" formArrayName="parts">
      <div class="row m-1">
        <p class="activity-text">
          <i class="numbered-icon">4</i>
          Welke onderdelen zijn er? (optioneel)
        </p>
        <div *ngFor="let part of parts.controls; index as i" class="p-0">
          <div [formGroupName]="i">
            <div class="row m-1 mb-2 mb-md-4">
              <label for="activityname-input" class="form-label">Naam onderdeel</label>
              <input type="text" class="form-control form-input" id="part-name-input" formControlName="name">
            </div>
            <div class="row m-1 mb-2 mb-md-4 align-items-baseline gx-3">
              <div class="col ps-0">
                <label for="starttime-input" class="form-label">Starttijd</label>
                <input type="time" class="form-control form-input" id="part-starttime-input" formControlName="start">
              </div>
              <div class="col pe-0">
                <label for="endtime-input" class="form-label">Eindtijd</label>
                <input type="time" class="form-control form-input" id="part-endtime-input" formControlName="end">
              </div>
            </div>
            <div class="row m-1">
              <p class="add-part-text" (click)="removePartField(i)" *ngIf="i > 0"><i class="add-part-icon">-</i>Verwijder dit onderdeel</p>
              <hr>
            </div>
          </div>
        </div>
      </div>
      <div class="row m-1 mb-2 mb-md-4">
        <p *ngIf="this.parts.length < 10" class="add-part-text" (click)="addPart()"><i class="add-part-icon">+</i>Voeg een onderdeel toe</p>
      </div>
      <div class="row mb-2 mb-md-4 m-1">
        <div class="col ps-0">
          <button (click)="changeStep(false, 3)" class="col btn btn-primary btn-previous">Vorige stap</button>
        </div>
        <div class="col pe-0">
          <button (click)="changeStep(true, 3)" class="col btn btn-primary btn-next">Volgende stap</button>
        </div>
      </div>
    </div>





    <div [hidden]="currentStep !== 4">
      <div class="row mb-4 m-1">
        <p class="activity-text mb-0">
          <i class="numbered-icon">5</i>
          Foto(s) toevoegen (optioneel)
        </p>
        <div class="p-0 mt-2">
          <p>Zet jouw activiteit in de schijnwerpers!</p>
          <p>Heb je een leuke activiteit gepland? Laat deze nóg meer opvallen door je eigen foto(s) toe te voegen.</p>
          <p>Met een persoonlijke foto krijgt jouw activiteit extra aandacht en kunnen deelnemers een beter beeld krijgen van wat ze kunnen verwachten. Upload hieronder één of meerdere foto's en zorg ervoor dat jouw activiteit eruit springt!</p>
          <p>Je kunt de volgorde van de foto's aanpassen door ze te slepen.</p>
          <b>Belangrijk: Liggende (landscape) foto's zien er beter uit dan staande (portrait) foto's.</b>
        </div>
      </div>
      <div class="row m-1">
        <div class="upload-error mb-4" *ngIf="imgUploadError">
          <i class="bi bi-exclamation-triangle"></i>{{ imgUploadError }}
        </div>
        <div class="upload-wrapper" id="draggable-container">
          <div class="upload-container"
               *ngFor="let image of images; index as i"
               [ngClass]="{'filled': image !== null, 'empty': image === null,'first-empty': i === getNextAvailableIndex()}">
            <div class="upload-icon"><i class="bi bi-cloud-plus"></i></div>
            <div *ngIf="image" class="image-wrapper">
              <img class="upload-image-thumbnail" [src]="image.src" alt="image">
              <div class="uploader-overlay">
                <span class="trash-icon" title="Foto verwijderen" (click)="deleteImage(i)">
                  <i class="bi bi-trash" aria-hidden="true" data-sem="Icon"></i>
                </span>
              </div>
            </div>
            <input class="upload-input" (change)="uploadImage($event)" type="file" id="image-input" accept="image/*" multiple>
          </div>
        </div>
      </div>
      <div class="row mb-4 m-1">
        {{ getCurrentImageCount() }} van 5 foto's gebruikt
      </div>
      <div class="row mb-4 m-1">
        <div class="col ps-0">
          <button (click)="changeStep(false, 4)" class="col btn btn-primary btn-previous">Vorige stap</button>
        </div>
        <div class="col pe-0">
          <button *ngIf="!postId" (click)="createActivity()" class="col btn btn-primary btn-next" [disabled]="submitDisabled">Aanmaken</button>
          <button *ngIf="postId" (click)="editActivity()" class="col btn btn-primary btn-next" [disabled]="submitDisabled">Wijzigen</button>
        </div>
      </div>
    </div>
  </div>
</form>
